import React from "react";
import Sidebar from "@/components/layout/Sidebar";
import MobileNav from "@/components/layout/MobileNav";

export default function AppLayout({ children, title, actions }) {
  return (
    <div className="min-h-screen bg-slate-50">
      <Sidebar />
      <MobileNav />
      <main className="lg:pl-64">
        <header className="sticky top-0 z-20 backdrop-blur-md bg-white/80 border-b border-slate-200">
          <div className="px-6 lg:px-10 py-5 flex items-center justify-between gap-4">
            <div>
              <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-slate-900" data-testid="page-title">
                {title}
              </h1>
            </div>
            <div className="flex items-center gap-2">{actions}</div>
          </div>
        </header>
        <div className="px-6 lg:px-10 py-8">{children}</div>
      </main>
    </div>
  );
}
